/**
  * @class meleDrawer
  * @description
  * container for ui
  *
  */

import meleElement from 'meleElement'

const PROPERTIES = _.extend({}, {
  open: { type: 'boolean', description: 'true to show all notifications, false to show only top one', default: false },
  job: { type: 'string', description: 'job name' },
  pages: { type: 'number', description: 'number of pages' },
  page: { type: 'number', description: 'current page' },
  error: { type: 'string', description: 'error message' },
  message: { type: 'string', description: 'message' },
  printing: { type: 'boolean', description: 'true if printing' },
  eventPrint: { type: 'function', description: 'event to print' },
  eventCancel: { type: 'function', description: 'event to cancel' },
}, meleElement._properties)

export default class melePrinter extends meleElement {
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Creates internal DOM structure.
  */
  init() {
    this.elMessage = this.appendChildren({
      tag: 'mele-text',
      class: 'message',
    })

    this.elError = this.appendChildren({
      tag: 'mele-text',
      class: 'error',
      hidden: true,
    })

    this.elButtons = this.appendChildren({
      tag: 'div',
      class: 'buttons',
      children: [
        { tag: 'mele-button', label: 'printer.close', type: 'actionbar', key: 'close', color: 'red', eventButtonClicked: this.close.bind(this) },
        { tag: 'mele-button', label: 'printer.repeat', type: 'actionbar', key: 'repeat', color: 'orange', hidden: true, eventButtonClicked: this.repeat.bind(this) },
        { tag: 'mele-button', label: 'printer.next', type: 'actionbar', key: 'next', color: 'blue', hidden: true, eventButtonClicked: this.next.bind(this) },

      ],
    })
  } // init

  jobChanged(value, old) {
    const repeat = this.elButtons.find('@repeat')
    value = !!value // force boolean
    repeat.hidden = !value
  }

  pagesChanged(value, old) {
    const next = this.elButtons.find('@next')
    if(!value || this.page === parseInt(value)) {
      next.hidden = true
    } else {
      next.hidden = false
    }
  }

  pageChanged(value, old) {
    const next = this.elButtons.find('@next')
    if(!value || this.pages === parseInt(value)) {
      next.hidden = true
    } else {
      next.hidden = false
    }
  }

  messageChanged(value, old) {
    this.elMessage.label = value
  }

  repeat() {
    if(!this.job || !this.page) {
      this.warn('no job to repeat')
      return
    }
    this.eventPrint(this, this.job, this.page)
  }

  eventPrint(self, job, page) {
  }

  eventCancel(self, job) {
    this.open = false
  }

  next() {
    if(!this.job || !this.page) {
      this.warn('no job to repeat')
      return
    }
    this.page = parseInt(this.page) + 1
    this.eventPrint(this, this.job, this.page)
  }

  close() {
    this.eventCancel(this, this.job)
  }

  errorChanged(value, old) {
    if(value) {
      this.elError.label = value
      this.elError.hidden = false
    } else {
      this.elError.label = ''
      this.elError.hidden = true
    }
  }

  printingChanged(value, old) {
    const next = this.elButtons.find('@next')
    const repeat = this.elButtons.find('@repeat')
    value = !!value // force boolean
    next.disabled = repeat.disabled = value
    if(value) {
      if(!this.page || !this.pages) {
        this.message = this.translate('printer.starting')
      } else {
        this.message = `${this.translate('printer.printing_page')} ${this.page} / ${this.pages}`
      }
    } else {
      if(!this.page || !this.pages) return
      if(parseInt(this.page) === parseInt(this.pages)) {
        this.message = this.translate('printer.finished')
      } else {
        this.message = `${this.translate('printer.printed_page')} ${this.page} / ${this.pages}`
      }
    }
  }

  reset() {
    this.job = ''
    this.pages = 0
    this.page = 0
    this.error = ''
    this.message = ''
    this.printing = false
    this.open = false
  }
} // class melePrinter

melePrinter._properties = PROPERTIES
melePrinter.observedAttributes = _.keys(PROPERTIES)

window.customElements.define('mele-printer', melePrinter)
